import { useEffect, useState, useCallback } from "react";
import { listSavedRoutes } from "./offlineDB";

/**
 * useOfflineIds — reactive Set of location IDs currently persisted in IDB.
 * Refreshes when a user saves/removes a route (via `td-offline-changed`).
 *
 * Returns { ids, total_bytes, refresh }.
 */
export function useOfflineIds() {
  const [state, setState] = useState({ ids: new Set(), total_bytes: 0, count: 0, records: [] });

  const refresh = useCallback(() => {
    listSavedRoutes()
      .then((records) => {
        const total_bytes = records.reduce((sum, r) => {
          try { return sum + JSON.stringify(r).length; } catch { return sum; }
        }, 0);
        setState({
          ids: new Set(records.map((r) => r.location_id)),
          total_bytes,
          count: records.length,
          records,
        });
      })
      .catch(() => setState({ ids: new Set(), total_bytes: 0, count: 0, records: [] }));
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener("td-offline-changed", refresh);
    return () => window.removeEventListener("td-offline-changed", refresh);
  }, [refresh]);

  return { ...state, refresh };
}
